module.exports = __webpack_public_path__ + "static/media/md-people.7e072eb3.svg";